import { combineReducers } from 'redux';
import simpleReducer from './simpleReducer';
import userStore from './user-reducers';
import headerStore from './header-reducer';
export default combineReducers({
  simpleReducer,
  userStore,
  headerStore,
});
